import React from "react";
import "./FeedbackForm.css";
import SecondaryButton from "../../../../../../Components/SecondaryButton/SecondaryButton";
import { withRouter } from "react-router-dom";
import TextInput from "../../../../../../Components/TextInput/TextInput";
import call from "../../../../../../API/API";

class FeedbackForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      feedbackError: "",
      feedbackMessage: "",
    };

    this.sendFeedback = this.sendFeedback.bind(this);
    this.handleTextInputOnChange = this.handleTextInputOnChange.bind(this);
  }

  handleTextInputOnChange(e) {
    this.setState({
      feedbackMessage: e.target.value,
    });
  }

  sendFeedback() {
    if (this.state.feedbackMessage !== "") {
      let feedbackObj = {
        label: "no label",
        feedback: this.state.feedbackMessage,
      };
      call.feedback
        .sendFeedback(feedbackObj)
        .then((res) => {
          if (res.success) {
            this.setState(
              {
                feedbackMessage: "",
              },
              () => {
                this.props.showSuccessBox(
                  "Success",
                  "Your feedback has been sent!"
                );
              }
            );
          } else {
            this.props.showErrorBox(
              "Error",
              "Your feedback could not be sent. Please try again."
            );
          }
        })
        .catch((err) => {
          this.props.history.push("/error", { error: err.message });
        });
    } else {
      this.props.showErrorBox(
        "Error",
        "Please fill feedback content before sharing."
      );
    }
  }

  render() {
    return (
      <section className="form feedback-form">
        <div className="feedback-row feedback-form-header">
          <h2 className="feedback-form-title headline-5">Feedback</h2>
          <p className="body-text">
            We'd love to hear from you! If you have any ideas or requests, just
            drop us a line.
          </p>
          <h3 className="feedback-form-sub-title">Your feedback</h3>
        </div>
        <div className="feedback-form-body feedback-row">
          <div className="feedback-body">
            <TextInput
              type="text"
              id="feedback"
              value={this.state.feedbackMessage}
              placeholder="How did you like working with Astronomic Network?"
              ref={this.textarea}
              spellCheck={false}
              handleTextInputOnChange={this.handleTextInputOnChange}
            />
          </div>
        </div>
        <div className="feedback-form-footer feedback-row">
          <SecondaryButton
            buttonText="Share feedback"
            onClickFunction={this.sendFeedback}
          />
        </div>
      </section>
    );
  }
}

export default withRouter(FeedbackForm);
